/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.Toggle = void 0;

var react_1 = __importDefault(require("react"));

var utils_1 = require("./utils");

var name = 'Toggle';
exports.name = name;

var Toggle = function Toggle(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            _this$props$activeInd = _this$props.activeIndex,
            activeIndex = _this$props$activeInd === void 0 ? 0 : _this$props$activeInd,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            _this$props$options = _this$props.options,
            options = _this$props$options === void 0 ? [] : _this$props$options,
            setActiveIndex = _this$props.setActiveIndex;
        return react_1.default.createElement(Frame, {
          className: ['Toggle__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Frame, {
          className: ['Toggle__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, options.map(function (view, index) {
          var _ref2;

          var toggleStyle = Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.toggle, index === 0 ? styles === null || styles === void 0 ? void 0 : styles.toggleFirst : {}, index === options.length - 1 ? styles === null || styles === void 0 ? void 0 : styles.toggleLast : {}, activeIndex === index ? styles === null || styles === void 0 ? void 0 : styles.toggleActive : {});
          return react_1.default.createElement(Text, {
            className: ['Toggle__controls-toggle', classes === null || classes === void 0 ? void 0 : classes.toggle, (_ref2 = {}, _defineProperty(_ref2, classes === null || classes === void 0 ? void 0 : classes.toggleActive, activeIndex === index), _defineProperty(_ref2, classes === null || classes === void 0 ? void 0 : classes.toggleFirst, index === 0), _defineProperty(_ref2, classes === null || classes === void 0 ? void 0 : classes.toggleLast, index === options.length - 1), _ref2)],
            key: view,
            onClick: function onClick() {
              return setActiveIndex && setActiveIndex(index);
            },
            style: toggleStyle
          }, view);
        })), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Toggle = Toggle;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f;

  return {
    container: Object.assign({
      display: 'flex',
      flexDirection: 'row'
    }, (_a = theme.Toggle) === null || _a === void 0 ? void 0 : _a.container),
    inner: Object.assign({
      display: 'flex',
      flex: 1,
      flexDirection: 'row'
    }, (_b = theme.Toggle) === null || _b === void 0 ? void 0 : _b.inner),
    toggle: Object.assign({
      background: '#A3A2A2',
      color: '#fff',
      cursor: 'pointer',
      flex: 1,
      padding: 10,
      textAlign: 'center'
    }, (_c = theme.Toggle) === null || _c === void 0 ? void 0 : _c.toggle),
    toggleActive: Object.assign({
      background: '#000'
    }, (_d = theme.Toggle) === null || _d === void 0 ? void 0 : _d.toggleActive),
    toggleFirst: Object.assign(Object.assign({}, utils_1.StyleUtils.borderRadius('5px 0px 0px 5px')), (_e = theme.Toggle) === null || _e === void 0 ? void 0 : _e.toggleFirst),
    toggleLast: Object.assign(Object.assign({}, utils_1.StyleUtils.borderRadius('0px 5px 5px 0px')), (_f = theme.Toggle) === null || _f === void 0 ? void 0 : _f.toggleLast)
  };
};

exports.style = style;